import { AuthenticationManager } from "@playit/shared-authentication";
import axios from "axios";
import { AnimationDetailsDTO } from "../dto/AnimationDetailsDTO";
import { AnimationDTO } from "../dto/AnimationDTO";
import { AnimationPreviewDTO } from "../dto/AnimationPreviewDTO";
import { AnimationsPagedQueryParametersDTO } from "../dto/AnimationsPagedQueryParametersDTO";

export class AnimationService {
  private static readonly baseUrl = `${process.env.REACT_APP_PLAYIT_CREATORAPI}`;

  private static getAuthConfig() {
    const token = AuthenticationManager.GetToken();

    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }

  private static getPagedConfig(
    page: number,
    pageSize: number,
    queryParams?: AnimationsPagedQueryParametersDTO
  ) {
    return {
      ...this.getAuthConfig(),
      params: {
        PageSize: pageSize,
        PageNumber: page,
        Name: queryParams?.name,
      },
    };
  }

  private static getTotalCount(headers: Record<string, unknown> | undefined) {
    const paginationHeader = headers?.["x-pagination"];
    if (typeof paginationHeader !== "string") {
      throw new Error("Missing x-pagination header");
    }

    return JSON.parse(paginationHeader)["totalCount"];
  }

  static async GetAnimations(
    orgId: string,
    page: number,
    pageSize: number,
    queryParams?: AnimationsPagedQueryParametersDTO
  ) {
    const path = `${this.baseUrl}/organizations/${orgId}/animations`;
    const config = this.getPagedConfig(page, pageSize, queryParams);

    try {
      const { data, headers } = await axios.get<AnimationDTO[]>(path, config);
      const totalCount = this.getTotalCount(headers);

      return {
        animations: data ?? [],
        totalCount,
      };
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  static async GetAnimationDetails(orgId: string, animationName: string) {
    const path = `${this.baseUrl}/organizations/${orgId}/animations/${animationName}`;
    const config = this.getAuthConfig();

    try {
      const { data, status } = await axios.get<AnimationDetailsDTO>(
        path,
        config
      );
      return status === 200 ? data : undefined;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  static async GetAnimationPreview(orgId: string, animationName: string) {
    const path = `${this.baseUrl}/organizations/${orgId}/animations/${animationName}/preview`;
    const config = this.getAuthConfig();

    try {
      const { data, status } = await axios.get<AnimationPreviewDTO>(
        path,
        config
      );
      return status === 200 ? data : undefined;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }
}
